import React from 'react';
import { FaEdit, FaTrash, FaFolder, FaTag } from 'react-icons/fa';
import {
  TreeContainer,
  TreeItem,
  TagName,
  TagActions,
  ActionButton,
  ChildrenContainer,
  TagIcon,
  TagCount
} from './styles';

const TagTreeItem = ({ tag, level = 0, onSelectTag, selectedTag, onDeleteTag, onEditTag }) => {
  const hasChildren = tag.children && tag.children.length > 0;
  const isSelected = selectedTag?.id === tag.id;

  const handleSelect = () => {
    if (isSelected) {
      onSelectTag(null); // Unselect if already selected
    } else {
      onSelectTag(tag);
    }
  };

  return (
    <TreeItem level={level} isSelected={isSelected}>
      <TagName onClick={handleSelect}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
          <TagIcon>
            {hasChildren ? <FaFolder /> : <FaTag />}
          </TagIcon>
          {tag.name}
          {hasChildren && <TagCount>({tag.children.length})</TagCount>}
        </div>
        
        <TagActions $show={isSelected}>
          <ActionButton onClick={(e) => {
            e.stopPropagation();
            onEditTag(tag);
          }} title="Edit tag">
            <FaEdit />
          </ActionButton>
          <ActionButton 
            onClick={(e) => {
              e.stopPropagation();
              onDeleteTag(tag.id);
            }}
            title="Delete tag"
            className="delete"
          >
            <FaTrash />
          </ActionButton>
        </TagActions>
      </TagName>

      {hasChildren && (
        <ChildrenContainer>
          {tag.children.map(child => (
            <TagTreeItem
              key={child.id}
              tag={child}
              level={level + 1}
              onSelectTag={onSelectTag}
              selectedTag={selectedTag}
              onDeleteTag={onDeleteTag}
              onEditTag={onEditTag}
            />
          ))}
        </ChildrenContainer>
      )}
    </TreeItem>
  );
};

const TagTree = ({ tags, selectedTag, onSelectTag, onDeleteTag, onEditTag }) => {
  return (
    <TreeContainer>
      {tags.map(tag => (
        <TagTreeItem
          key={tag.id}
          tag={tag}
          onSelectTag={onSelectTag}
          selectedTag={selectedTag}
          onDeleteTag={onDeleteTag}
          onEditTag={onEditTag}
        />
      ))}
    </TreeContainer>
  );
};

export default TagTree; 